import React from 'react';

export default function DeadlineComponents({ milestones = false, posts }) {
    const duration = posts?.duration || 0;

    const durationMap = {
        1: ['hour', 'hours'],
        2: ['day', 'days'],
        3: ['week', 'weeks'],
        4: ['month', 'months'],
    };

    const unit =
        durationMap[posts?.duration_type]?.[
        duration > 1 ? 1 : 0
        ] || '';

    return (
        <>
            {milestones ? "" : `Deadline:`}&nbsp;{duration}&nbsp;{unit}
        </>
    );
}
